import { message } from "antd";
import * as React from "react";

import { AdvisorButton } from "./AdvisorButton";
import {
  IAdvisorRawOfferPackage,
  readVariantPackageValues,
  useApplyAdvisorPackage,
} from "./applyPackage";
import { Loader } from "./Loader";

/** One "Use <label>?" button per variant on the S5D comparison screen. */
export function VariantPackageButtons({
  packages,
  onApplied,
}: {
  packages: Record<string, IAdvisorRawOfferPackage>;
  onApplied: () => void;
}) {
  const applyAdvisorPackage = useApplyAdvisorPackage();
  const [applyingLabel, setApplyingLabel] = React.useState<string | null>(null);

  const entries = Object.entries(packages).filter(
    ([, pkg]) => readVariantPackageValues(pkg) !== null
  );
  if (entries.length === 0) return null;

  const handleClick = async (label: string, pkg: IAdvisorRawOfferPackage) => {
    const values = readVariantPackageValues(pkg);
    if (!values) return;

    setApplyingLabel(label);
    try {
      await applyAdvisorPackage(values);
      message.success(`${label} offer applied to the offer modeller.`);
      onApplied();
    } finally {
      setApplyingLabel(null);
    }
  };

  return (
    <div className="mt-4 flex flex-wrap gap-2">
      {entries.map(([label, pkg]) => (
        <AdvisorButton
          key={label}
          variant="primary"
          size="sm"
          onClick={() => handleClick(label, pkg)}
          disabled={applyingLabel !== null}
        >
          {applyingLabel === label ? (
            <Loader variant="circular" size="sm" />
          ) : null}
          {applyingLabel === label ? "Applying…" : `Use ${label}?`}
        </AdvisorButton>
      ))}
    </div>
  );
}
